import store from "@/store";

export const GetPagination = ({ pagination }) => pagination;
export const GetRole = ({ role }) => role;

export const GetCan = () => (permission) => {
  if (!permission) {
    return true;
  }

  /**
   * @description Verificação para excluir assim que os modulos tiverem mais avançados.
   * Por equanto vamos deixar todos com permissão
   */
  return true;

  let user = store.getters["auth/GetUser"];

  if (
    user.roles.indexOf(process.env.VUE_APP_ROLE_ADMIN) > -1 ||
    user.permissions.indexOf(permission) > -1
  ) {
    return true;
  }
  return false;
};
